/* eslint-disable */
export const AUTH_LOGIN = `[AUTH] LOGIN`;
export const AUTH_LOGIN_COMPLETE = `[AUTH] LOGIN COMPLETE`;
export const AUTH_LOGIN_ERROR = `[AUTH] LOGIN ERROR`;
export const AUTH_LOGIN_SUCCESS = `[AUTH] LOGIN SUCCESS`;

export const AUTH_LOGOUT = `[AUTH] LOGOUT`;
export const AUTH_LOGOUT_COMPLETE = `[AUTH] LOGOUT COMPLETE`;
export const AUTH_LOGOUT_ERROR = `[AUTH] LOGOUT ERROR`;
export const AUTH_LOGOUT_SUCCESS = `[AUTH] LOGOUT SUCCESS`;

export const AUTH_PRESENCE_CHANGED = `[AUTH] PRESENCE CHANGED`;
export const AUTH_PRESENCE_CHANGED_COMPLETE = `[AUTH] PRESENCE CHANGED COMPLETE`;
export const AUTH_PRESENCE_CHANGED_ERROR = `[AUTH] PRESENCE CHANGED ERROR`;
export const AUTH_PRESENCE_CHANGED_NEXT = `[AUTH] PRESENCE CHANGED NEXT`;

export const AUTH_STATE_CHANGED = `[AUTH] STATE CHANGED`;
export const AUTH_STATE_CHANGED_COMPLETE = `[AUTH] STATE CHANGED COMPLETE`;
export const AUTH_STATE_CHANGED_ERROR = `[AUTH] STATE CHANGED ERROR`;
export const AUTH_STATE_CHANGED_NEXT = `[AUTH] STATE CHANGED NEXT`;

export const AUTH_FORGOT_PASSWORD_CLICKED = `[AUTH] FORGOT PASSWORD CLICKED`;
export const AUTH_HELP_LINK_CLICKED = `[AUTH] HELP LINK CLICKED`;
export const AUTH_UNLOCK_CLICKED = `[AUTH] UNLOCK CLICKED`;
export const AUTH_TNC_LINK_CLICKED = `[AUTH] T&C CLICKED`;
